'use strict'

export function checkShadowHeader(header) {
  const pixelsScrolled = 5

  if (window.pageYOffset > pixelsScrolled && !header.classList.contains('navigation--shadow')) {
    header.classList.add('navigation--shadow')
  }
  if (window.pageYOffset < pixelsScrolled && header.classList.contains('navigation--shadow')) {
    header.classList.remove('navigation--shadow')
  }
}

export function onScroll() {
  // if scroll show header shadow
  const header = document.querySelector('nav.navigation')
  checkShadowHeader(header)
  checkHIWPlayOnViewport()
}

function checkHIWPlayOnViewport() {
  const hiwAnimations = Array.from(document.querySelectorAll('[data-hiw-playonviewport="true"]'))

  if (hiwAnimations.length > 0) {
    hiwAnimations.forEach(hiwAnimation => {
      const animationClientRect = hiwAnimation.getBoundingClientRect()
      if (animationClientRect.top <= (window.innerHeight * 0.60) && hiwAnimation.querySelectorAll('nav a')[0].getAttribute('data-handler') === 'true') {
        hiwAnimation.querySelectorAll('nav a')[0].click()
        hiwAnimation.setAttribute('data-hiw-playonviewport', 'false')
      }
    })
  }
}
